import { ProColumns } from '@ant-design/pro-components';
import { Col, Form, InputNumber, Modal, Radio, Row, Space, Table } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// icons
import { ExclamationCircleOutlined, MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useWatch } from 'antd/es/form/Form';
import CustomCheckbox from 'base/ui/components/CustomCheckbox';
import CustomRadio from 'base/ui/components/CustomRadio';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import CustomDatePicker from 'base/ui/components/Input/customDatePicker';
import CustomInputNumber from 'base/ui/components/Input/customInputNumber';
import CustomInputString from 'base/ui/components/Input/customInputString';
import moment from 'moment';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';

// LỊCH NHẮC NHỞ

export type TableListItem = {
  key: number;
  stt: number;
  congty: string;
  maDK: string;
  maCRM: string;
  tenKH: string;
  sdt: string;
  maSAP: string;
  tenSP: string;
  soSerial: string;
  donHang: string;
  phieuGH: string;
  phieuBH: string;
  tenBH: string;
  ngayDK: string;
  BHdenNgay: string;
  NNtruoc: string;
  solanNN: number;
  nhacNho: string;
};

const commonDate = [
  { label: 'Ngày', value: 'date' },
  { label: 'Tuần', value: 'week' },
  { label: 'Tháng', value: 'month' },
  // { label: 'Năm', value: 'year' },
];

const dayOfWeek = [
  { label: 'Thứ 2', value: 'monday' },
  { label: 'Thứ 3', value: 'tuesday' },
  { label: 'thứ 4', value: 'wednesday' },
  { label: 'thứ 5', value: 'thursday' },
  { label: 'thứ 6', value: 'friday' },
  { label: 'thứ 7', value: 'saturday' },
  { label: 'chủ nhật', value: 'sunday' },
];

const defaultColumn: ProColumns<TableListItem>[] = [
  {
    title: 'STT',
    dataIndex: 'stt',
    fixed: true,
    width: 50,
    align: 'center',
  },
  {
    title: 'Công ty',
    dataIndex: 'congty',
    width: 200,
  },
  {
    title: 'Mã đăng ký',
    dataIndex: 'maDK',
    width: 100,
  },
  {
    title: 'Mã CRM khách hàng',
    dataIndex: 'maCRM',
    width: 100,
  },
  {
    title: 'Tên khách hàng',
    dataIndex: 'tenKH',
    width: 100,
  },
  {
    title: 'Số điện thoại',
    dataIndex: 'sdt',
    width: 100,
  },
  {
    title: 'Mã SAP sản phẩm',
    dataIndex: 'maSAP',
    width: 100,
  },
  {
    title: 'Tên sản phẩm',
    dataIndex: 'tenSP',
    width: 150,
  },
  {
    title: 'Số serial',
    dataIndex: 'soSerial',
    width: 150,
  },
  {
    title: 'Đơn hàng',
    dataIndex: 'donHang',
    width: 100,
  },
  {
    title: 'Phiếu giao hàng',
    dataIndex: 'phieuGH',
    width: 100,
  },
  {
    title: 'Phiếu bảo hành',
    dataIndex: 'phieuBH',
    width: 100,
  },
  {
    title: 'Tên bảo hành',
    dataIndex: 'tenBH',
    width: 100,
  },
  {
    title: 'Ngày đăng ký',
    dataIndex: 'ngayDK',
    align: 'center',
    width: 100,
  },
  {
    title: 'Bảo hành đến ngày',
    dataIndex: 'BHdenNgay',
    align: 'center',
    width: 100,
  },
  {
    title: 'Nhắc nhở trước',
    dataIndex: 'NNtruoc',
    width: 100,
  },
  {
    title: 'Số lần đã nhắc nhở',
    dataIndex: 'number',
    align: 'right',
    width: 100,
  },
  {
    title: 'Nhắc nhở',
    dataIndex: 'nhacNho',
    width: 100,
  },
];

const defaultColumnAdd = cloneDeep(defaultColumn);

const tableListDataSource: TableListItem[] = [
  {
    key: 1,
    stt: 1,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Vũ Trà My',
    sdt: '0963240423',
    maSAP: '610000098',
    tenSP: 'Bếp 3 từ, mã số MI 593B',
    soSerial: '220161000009800004',
    donHang: '2000076148',
    phieuGH: '7000087522',
    phieuBH: '1000087522',
    tenBH: '12 Tháng',
    ngayDK: '01/01/2023',
    BHdenNgay: '01/12/2023',
    NNtruoc: '30 Ngày',
    solanNN: 0,
    nhacNho: 'Không',
  },
  {
    key: 2,
    stt: 2,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Vũ Trà My',
    sdt: '0963240423',
    maSAP: '610000098',
    tenSP: 'Bếp 3 từ, mã số MI 593B',
    soSerial: '220161000009800004',
    donHang: '2000076148',
    phieuGH: '7000087522',
    phieuBH: '1000087522',
    tenBH: '12 Tháng',
    ngayDK: '01/01/2023',
    BHdenNgay: '01/12/2023',
    NNtruoc: '30 Ngày',
    solanNN: 0,
    nhacNho: 'Không',
  },
  {
    key: 3,
    stt: 3,
    congty: 'Công Ty TNHH Malloca Việt Nam',
    maDK: '128711',
    maCRM: '100448581',
    tenKH: 'Vũ Trà My',
    sdt: '0963240423',
    maSAP: '610000098',
    tenSP: 'Bếp 3 từ, mã số MI 593B',
    soSerial: '220161000009800004',
    donHang: '2000076148',
    phieuGH: '7000087522',
    phieuBH: '1000087522',
    tenBH: '12 Tháng',
    ngayDK: '01/01/2023',
    BHdenNgay: '01/12/2023',
    NNtruoc: '30 Ngày',
    solanNN: 0,
    nhacNho: 'Không',
  },
];

const createRemindSchedules = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.remind-list') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();
    const [formModal] = Form.useForm();
    const [selectRows, setSelectRows] = useState<TableListItem[]>([]);
    // Custom default columns table with resizeable
    const [columns, setColumns] = useState<ProColumns<TableListItem>[]>(defaultColumn);
    const [columnsAdd, setColumnAdd] = useState<ProColumns<TableListItem>[]>(defaultColumnAdd);

    // modal confirm when click button 'aplly to rows select'
    const [modal, contextHolder] = Modal.useModal();

    // ======================================================== function =================================================================
    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // hidden modal (Add)
    const hideModal = () => {
      setOpen({ ...open, openModal: false });
    };
    const handleAdd = () => {
      setOpen({ ...open, openModal: true });
    };
    const handleDelete = () => {};

    // Function handle resize columns
    const handleResize =
      (index: number) =>
      (e: any, { size }: any) => {
        // Set columns
        setColumns((prevColumns) => {
          const nextColumns = [...prevColumns];
          nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
          };
          return nextColumns;
        });
      };
    const handleResizeTableAdd =
      (index: number) =>
      (e: any, { size }: any) => {
        // Set columns
        setColumnAdd((prevColumns) => {
          const nextColumns = [...prevColumns];
          nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
          };
          return nextColumns;
        });
      };

    // lấy value của trong form
    const schedules = useWatch('schedules', formModal);
    const dates = useWatch('listDate', formModal);
    const typeTime = useWatch('commonDate', formModal);
    const isCheckWatch = useWatch('isCheck', form);

    useEffect(() => {
      (() => {
        const tempt = cloneDeep(columns);
        if (isCheckWatch) {
          tempt.splice(
            tempt.length,
            0,
            {
              title: t('remind-calendar.remind-date-kh'),
              dataIndex: 'ngayNNKH',
              align: 'center',
              width: 150,
            },
            {
              title: t('remind-calendar.remind-date-tt'),
              dataIndex: 'ngayTTNN',
              align: 'center',
              width: 150,
            },
            {
              title: t('remind-calendar.create-by'),
              dataIndex: 'createBy',
              width: 100,
            },
            {
              title: t('remind-calendar.create-date'),
              dataIndex: 'createDate',
              align: 'center',
              width: 100,
            },
          );
          return setColumns(tempt);
        } else {
          return setColumns(defaultColumn);
        }
      })();
    }, [isCheckWatch]);

    // handle confirm in modal cofirm form
    const confirm = () => {
      const data = formModal.getFieldsValue();
      let content = '';
      if (data.schedules === 'once') {
        content = `Bạn có chắc muốn thêm mới ${dates.length} lịch nhắc nhở bảo hành cho ${selectRows.length} mục được chọn?`;
      } else {
        switch (data.commonDate) {
          case 'date':
            content = `Bạn có chắc muốn thêm mới lịch nhắc nhở bảo hành ${
              data.repeat ? data.repeat : 0
            } ngày/lần, bắt đầu từ ${moment(data.dateStart).format('DD/MM/YYYY')} đến ${moment(data.dateFinish).format(
              'DD/MM/YYYY',
            )} cho ${selectRows.length} mục được chọn?`;
            break;
          case 'month':
            content = `Bạn có chắc muốn thêm mới lịch nhắc nhở bảo hành ${
              data.repeat ? data.repeat : 0
            } tháng/lần vào ngày ${data.inDate}, bắt đầu từ ${moment(data.dateStart).format('DD/MM/YYYY')} đến ${moment(
              data.dateFinish,
            ).format('DD/MM/YYYY')} cho ${selectRows.length} mục được chọn?`;
            break;
          case 'week':
            content = `Bạn có chắc muốn thêm mới lịch nhắc nhở bảo hành ${data.repeat ? data.repeat : 0} tuần/lần vào ${
              dayOfWeek.find((i) => i.value === data.inDay)?.label
            }, bắt đầu từ ${moment(data.dateStart).format('DD/MM/YYYY')} đến ${moment(data.dateFinish).format(
              'DD/MM/YYYY',
            )} cho ${selectRows.length} mục được chọn?`;
            break;
          default:
            break;
        }
      }

      const instance = modal.confirm({
        title: t('btn.warning'),
        icon: <ExclamationCircleOutlined />,
        content: content,
        footer: (
          <div className="flex gap-4 justify-end mt-4">
            <CustomButton
              onClick={() => {
                instance.destroy();
              }}
            >
              {t('btn.cancel')}
            </CustomButton>
            <CustomButton
              onClick={() => {
                instance.destroy();
              }}
              type="primary"
            >
              {t('btn.continue')}
            </CustomButton>
          </div>
        ),
      });
    };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.remind-list'),
          },
        ]}
        extras={
          <>
            <CustomButton
              onClick={() => {
                if (isCheckWatch) {
                  handleDelete();
                } else {
                  handleAdd();
                }
              }}
              type="primary"
            >
              {isCheckWatch ? t('btn.delete-calendar') : t('btn.add-calendar')}
            </CustomButton>

            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<TableListItem>
            columns={columns}
            handleResize={handleResize}
            rowSelection={{
              selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
              onChange(selectedRowKeys, selectedRows, info) {
                setSelectRows(selectedRows);
              },
            }}
            size="small"
            dataSource={tableListDataSource}
            scroll={{ x: 2800, y: 500 }}
            search={false}
            pagination={{
              pageSize: 5,
            }}
            rowKey="key"
            tableAlertOptionRender={() => {
              return null;
            }}
            tableAlertRender={false}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox onClose={onClose} open={open.openDrawer}>
          <SearchForm form={form} onFinish={console.log}>
            {/* công ty */}
            <SearchItem name={'congty'} label={t('search-form.company')}>
              <CustomInputString />
            </SearchItem>
            {/* mã crm khách hàng và tên bảo hành */}
            <SearchItem name={'maCRM'} label={t('search-form.crm-customer-code')} start>
              <CustomInputString />
            </SearchItem>

            <SearchItem name={'tenBH'} label={t('search-form.guarantee-name')}>
              <CustomInputString />
            </SearchItem>

            {/* tên khách hàng và số sê-ri */}
            <SearchItem name={'tenKH'} label={t('search-form.customer-name')}>
              <CustomInputString />
            </SearchItem>

            <SearchItem name={'serial'} label={t('search-form.series')}>
              <CustomInputString />
            </SearchItem>

            {/* mã SAP sản phẩm và đơn hàng */}
            <SearchItem name={'maSAP'} label={t('search-form.sap-product-code')}>
              <CustomInputString />
            </SearchItem>

            <SearchItem name={'donHang'} label={t('search-form.order')}>
              <CustomInputString />
            </SearchItem>

            {/* tên sản phẩm và phiếu giao hàng */}
            <SearchItem name={'tenSP'} label={t('search-form.product-name')}>
              <CustomInputString />
            </SearchItem>

            <SearchItem name={'phieuGH'} label={t('search-form.delivery-note')}>
              <CustomInputString />
            </SearchItem>

            {/* Ngày đăng kí */}
            <SearchItem name={'dateDK'} label={t('search-form.register-date')}>
              <CustomDatePicker />
            </SearchItem>
            {/* từ ... đến */}
            <SearchItem name={'tuDK'} label={t('search-form.from')} start>
              <CustomDatePicker />
            </SearchItem>

            <SearchItem name={'denDK'} label={t('search-form.to')}>
              <CustomDatePicker />
            </SearchItem>

            {/* Ngày kết thúc */}
            <SearchItem name={'dateKT'} label={t('search-form.end-date')}>
              <CustomDatePicker />
            </SearchItem>
            {/* từ ... đến */}
            <SearchItem name={'tuKT'} label={t('search-form.from')} start>
              <CustomDatePicker />
            </SearchItem>

            <SearchItem name={'denKT'} label={t('search-form.to')}>
              <CustomDatePicker />
            </SearchItem>

            {/* checkbox xem lịch nhắc nhở đã tạo */}
            <div className="col-span-4">
              {/* thêm valuePropName để lấy được value của checkbox trong form */}
              <SearchItem
                name={'isCheck'}
                label={t('search-form.view-calendar')}
                valuePropName="checked"
                className="!m-0"
              >
                <CustomCheckbox />
              </SearchItem>
            </div>
            <div className="col-span-4 sticky bottom-[-24px] py-2 bg-white w-full">
              <CustomButton htmlType="submit" className="my-auto" type="primary">
                {t('btn.search')}
              </CustomButton>
            </div>
          </SearchForm>
        </SearchBox>

        {/* form modal */}
        <Modal
          width={1500}
          title={<p className="uppercase">{t('remind-calendar.modal-add-title')}</p>}
          open={open.openModal}
          onOk={hideModal}
          onCancel={hideModal}
          footer={<></>}
        >
          <Form
            form={formModal}
            initialValues={{ schedules: 'once', listDate: [{ first: undefined }], commonDate: 'date' }}
          >
            <div className="flex gap-16">
              <Form.Item className="mb-0" name="schedules">
                <Radio.Group>
                  <CustomRadio value="once">{t('remind-calendar.once')}</CustomRadio>
                  <CustomRadio value="period">{t('remind-calendar.periodic')}</CustomRadio>
                </Radio.Group>
              </Form.Item>
            </div>

            {schedules === 'once' ? (
              <>
                <Form.List name="listDate">
                  {(fields, { add, remove }) => {
                    return (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                            <Form.Item
                              {...restField}
                              name={[name, 'date']}
                              className="!m-0"
                              rules={[{ required: true, message: t('message.input-date') }]}
                            >
                              <CustomDatePicker className="w-[220px]" />
                            </Form.Item>
                            {index === 0 ? (
                              <PlusCircleOutlined onClick={() => add()} />
                            ) : (
                              <MinusCircleOutlined onClick={() => remove(name)} />
                            )}
                          </Space>
                        ))}
                      </>
                    );
                  }}
                </Form.List>
              </>
            ) : (
              <Row gutter={10}>
                <Col span={6}>
                  <Form.Item
                    name="dateStart"
                    labelCol={{ span: 8 }}
                    rules={[{ required: true, message: t('message.input-date') }]}
                    label={t('search-form.start-date')}
                  >
                    <CustomDatePicker />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="dateFinish"
                    labelCol={{ span: 8 }}
                    rules={[{ required: true, message: t('message.input-date') }]}
                    label={t('search-form.end-date')}
                  >
                    <CustomDatePicker />
                  </Form.Item>
                </Col>
                <Col span={12}></Col>
                <Col span={6}>
                  <Form.Item
                    name="repeat"
                    labelCol={{ span: 8 }}
                    rules={[{ required: true, message: t('message.input-text') }]}
                    label={t('search-form.repeat')}
                  >
                    <CustomInputNumber min={0} className=" !text-right" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label=" "
                    name="commonDate"
                    rules={[{ required: true, message: t('message.input-date') }]}
                    colon={false}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <CustomSelect options={commonDate} />
                  </Form.Item>
                </Col>
                {typeTime === 'month' && (
                  <>
                    <Col span={6}>
                      <Form.Item
                        label={t('search-form.on-day')}
                        rules={[{ required: true, message: t('message.input-date') }]}
                        name={'inDate'}
                        labelCol={{ span: 8 }}
                      >
                        <InputNumber min={1} max={31} className="!rounded-none w-full !text-right" />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {typeTime === 'week' && (
                  <>
                    <Col span={6}>
                      <Form.Item
                        name="inDay"
                        label={t('search-form.day-of-week')}
                        rules={[{ required: true, message: t('message.input-text') }]}
                        labelCol={{ span: 8 }}
                      >
                        <CustomSelect options={dayOfWeek} />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            )}

            <Form.Item>
              <CustomButton type="primary" htmlType="submit" onClick={confirm}>
                {t('btn.apply-all')}
              </CustomButton>
              {contextHolder}
            </Form.Item>
          </Form>

          {/* Table */}
          <CustomProTable<TableListItem>
            columns={columnsAdd}
            handleResize={handleResizeTableAdd}
            rowSelection={{
              selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
              onChange(selectedRowKeys, selectedRows, info) {
                setSelectRows(selectedRows);
              },
            }}
            size="small"
            dataSource={tableListDataSource}
            scroll={{ x: 2500, y: 500 }}
            search={false}
            pagination={{
              pageSize: 5,
            }}
            rowKey="key"
            tableAlertRender={false}
          />
        </Modal>
      </PageWrapper>
    );
  });
};

export default createRemindSchedules;
